export const SPECIFIED_PER_PERSON = 'specified_per_person';
export const FIXED_PER_PERSON = 'fixed_per_person';
export const EVEN_SPLIT = 'even_split';



// WEBPACK FOOTER //
// ./src/lib/split-types.js